import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import ShippingTaxReturnForm, {
  ShippingTaxReturnFormProps
} from "../../../pages/program/shippingAndTax/components/ShippingTaxReturnForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ShippingTaxReturnFormProps {
}

type Props = OwnProps;

// @ts-ignore
const ShippingTaxReturnModal = NiceModal.create<Props>(({shippingAndTax, header, onClose, ...rest}) => {
  const modal = useModal()

  const handleClose = (e) => {
    modalClose(e, modal, onClose)
  }

  return (
    <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
      <ShippingTaxReturnForm shippingAndTax={shippingAndTax} {...rest}/>
    </SlideOver>
  )
})

export default ShippingTaxReturnModal;
